import { get, post } from './fetcher';

// 랭커 검증 / 웹사이트표기(확정) 관리자 API
// 백엔드: /api/admin/validation/* (ValidationController)
const V = '/api/admin/validation';

// 스크래핑 작업 목록
export const getValidationJobs = async (token, limit = 100) => {
  const r = await get(`${V}/jobs`, { limit }, token);
  if (r?.success) return r.data || [];
  throw new Error(r?.message || '작업 목록 조회 실패');
};

// 검증 payload (그리드 rows + columns)
export const getValidationPayload = async (token, masterIds) => {
  const ids = Array.isArray(masterIds) ? masterIds.join(',') : String(masterIds || '');
  const r = await get(`${V}/payload`, { masterIds: ids }, token);
  if (r?.success) return { rows: r.data?.rows || [], columns: r.data?.columns || [] };
  throw new Error(r?.message || '검증 데이터 조회 실패');
};

// 검증 저장 → weekly
export const saveValidationRows = async (token, { baseDate, rows, overwrite = false }) => {
  const r = await post(`${V}/save`, { baseDate, rows, overwrite }, token);
  // AdminApiResponse<ValidationSaveResult>: data 에 ok/needConfirm/count 포함
  const d = r?.data || {};
  return {
    ok: !!d.ok,
    needConfirm: !!d.needConfirm,
    message: d.message || r?.message,
    count: d.count || 0,
  };
};

// weekly 기준일별 건수
export const getWeeklyDates = async (token) => {
  const r = await get(`${V}/weekly-dates`, {}, token);
  if (r?.success) return r.data || [];
  throw new Error(r?.message || '검증일자 조회 실패');
};

// 확정: weekly → ranker_fix
export const confirmValidation = async (token, { baseDates, masterIds = [], applyNow = true, confirmDate }) => {
  const r = await post(`${V}/confirm`, { baseDates, masterIds, applyNow, confirmDate }, token);
  const d = r?.data || {};
  return {
    ok: !!r?.success && !!d.ok,
    message: d.message || r?.message,
    inserted: d.inserted || 0,
    validationDate: d.validationDate,
    applyNow: !!d.applyNow,
  };
};

// 확정 기준일별 목록
export const getPublishDates = async (token) => {
  const r = await get(`${V}/publish-dates`, {}, token);
  if (r?.success) return r.data || [];
  throw new Error(r?.message || '확정 목록 조회 실패');
};

// 확정 상세
export const getPublishDetail = async (token, date) => {
  const r = await get(`${V}/publish-detail`, { date }, token);
  if (r?.success) return r.data || [];
  throw new Error(r?.message || '확정 상세 조회 실패');
};

// 적용 ON/OFF
export const setPublishApply = async (token, { validationDate, isApplied }) => {
  const r = await post(`${V}/apply`, { validationDate, isApplied }, token);
  return { ok: !!r?.success, message: r?.message, affected: r?.data?.affected || 0 };
};
